import { useSelector } from 'react-redux';
import { ComponentContainer } from '@styles/layout';
import { AppVariant } from '@model/config/brands';
import { BaseComponent } from '@model/content';
import { getCMSDestination } from '@state/cms';
import { ToursCallToBookContainer } from '@components/content/tours';
import { CallToBook } from '@components/call-to-book/CallToBook';
import { isTourTripType } from '@util/tours';

export const CallToBookContainer = (props: BaseComponent) => {
  const { path, tripType } = props;
  if (tripType) {
    if (isTourTripType(tripType)) {
      return <ToursCallToBookContainer {...props} />;
    } else {
      const isWhiteLabel = AppVariant.isWhitelabel();
      const destination = useSelector(getCMSDestination(path));

      if (isWhiteLabel && destination) {
        return (
          <ComponentContainer>
            <CallToBook {...props} destination={destination} tripType={tripType} />
          </ComponentContainer>
        );
      }
    }
  }
  return null;
};
